import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  makeSelectIsSurveySaving,
  makeSelectTermsAndConditionsSaving,
  makeSelectIsSurveyNameSaving,
} from 'containers/Survey/selectors';
import { makeSelectQuestionnaireSaving } from 'containers/QuestionnairePage/selectors';
import { makeSelectIsTargetingSaving } from 'containers/TargetingPage/selectors';
import { makeSelectIsSaving as makeSelectIsLinkShareSaving } from 'containers/LinkShare/selectors';
import { makeSelectIsSaving as makeSelectIsLinkSettingsSaving } from 'containers/LinkSettings/selectors';

export const useIsSaving = () => {
  const isSurveySaving = useSelector(makeSelectIsSurveySaving);
  const isQuestionnaireSaving = useSelector(makeSelectQuestionnaireSaving);
  const isTargetingSaving = useSelector(makeSelectIsTargetingSaving);
  const isLinkSharesSaving = useSelector(makeSelectIsLinkShareSaving);
  const isLinkSettingsSaving = useSelector(makeSelectIsLinkSettingsSaving);
  const isTermsAndConditionsSaving = useSelector(
    makeSelectTermsAndConditionsSaving,
  );
  const IsSurveyNameSaving = useSelector(makeSelectIsSurveyNameSaving);

  return useMemo(
    () =>
      Boolean(
        isSurveySaving ||
        isQuestionnaireSaving ||
        isTargetingSaving ||
        isLinkSharesSaving ||
        isLinkSettingsSaving ||
        isTermsAndConditionsSaving ||
        IsSurveyNameSaving,
      ),
    [
      isSurveySaving,
      isQuestionnaireSaving,
      isTargetingSaving,
      isLinkSharesSaving,
      isLinkSettingsSaving,
      isTermsAndConditionsSaving,
      IsSurveyNameSaving,
    ],
  );
};

export default useIsSaving;
